<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="part1" style="margin-top:20px;"><span><b class="sans_normal">I’m fading.</b></span></p>
<p class="noind" style="margin-top:30px;"><b class="sans_normal">You always knew this would happen again.</b></p>
<p class="right" style="margin-top:30px;"><b class="sans_normal">Are you prepared?</b></p>
<p class="center" style="margin-top:30px;"><span>   <b class="sans_normal">For what?</b></span></p>
<p class="ind" style="margin-top:30px;"><b class="sans_normal">For return.</b></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 6part1.vue?752cd21e